import React from 'react';
import { View } from 'react-native';
import { Button, ButtonGroup, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import { tierThemes } from 'features/premium/benefits';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { selectEligibleFreeTrialDays } from 'features/premium/selectors';
import { useAppSelector } from 'store/hooks';
import UserDeckView from 'login/components/UserDeckView';
import CompareFreeAndPremiumTable from './CompareFreeAndPremiumTable';
const strings = {
    default: 'Emma Plans help us stay independent and build the best product for you. We’d love to see you on our premium plans. Upgrading means supporting our work.',
};
const OnboardingHowFreeTrialWorksWarningModalContent = ({ onConfirm, onDismiss, shouldSeePremiumTrialScreen, tier, showCompareTable, showNumbers, showUserDeck, }) => {
    const styles = useStyles(styleSet);
    const eligibleFreeTrialDays = useAppSelector(selectEligibleFreeTrialDays);
    const shouldShowCompareTable = !!showCompareTable && !showUserDeck;
    const shouldShowNumbers = !!showNumbers && !showUserDeck;
    return (<View>
      {!!showUserDeck && (<>
          <View style={styles.deckContainer}>
            <UserDeckView embedded darkBackground/>
          </View>
          <Text Text-20 centered style={styles.title}>
            Are you sure? 🧸
          </Text>
        </>)}
      <Text centered Secondary TextThin-14 style={[styles.text, !shouldShowCompareTable && styles.textTopMargin]}>
        {/* eslint-disable-next-line no-nested-ternary */}
        {showUserDeck && shouldSeePremiumTrialScreen ? (<>
            Our members love {tierThemes[tier].name}.{' '}
            <Text Text-14 Secondary>
              Try it completely free for {eligibleFreeTrialDays} days
            </Text>{' '}
            to see how much more you could save and track!
          </>) : shouldSeePremiumTrialScreen ? (`You can use Emma Basic for free, but ${tierThemes[tier].name} unlocks all the benefits and you can try them for free for ${eligibleFreeTrialDays} days.`) : (strings.default)}
      </Text>
      {!!shouldShowCompareTable && (<CompareFreeAndPremiumTable premiumTier={tier}/>)}
      {!!shouldShowNumbers && (<View style={styles.numbersView}>
          <View style={styles.numbersContainer}>
            <Text Text-14>Over</Text>
            <Spacer h={4}/>
            <Text Text-20 Primary>
              3M
            </Text>
            <Text TextThin-14 Secondary>
              downloads
            </Text>
          </View>
          <View style={styles.numbersContainer}>
            <Text Text-14 centered>
              Get
            </Text>
            <Spacer h={4}/>
            <Text Text-20 Primary>
              20+
            </Text>
            <Text TextThin-14 Secondary>
              premium features
            </Text>
          </View>
        </View>)}
      {!shouldShowCompareTable && (<ButtonGroup>
          <Button brandReversed title="Yes, I am sure" onPress={onConfirm}/>
          <Button brand title="No, let me try" onPress={onDismiss}/>
        </ButtonGroup>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    text: {
        marginBottom: rem(16),
        paddingHorizontal: rem(16),
    },
    textTopMargin: {
        marginTop: rem(16),
    },
    savingCard: {
        backgroundColor: colors.background.dark,
    },
    numbersView: {
        gap: rem(16),
        marginTop: rem(8),
        flexDirection: 'row',
        marginBottom: rem(24),
        paddingHorizontal: rem(16),
    },
    numbersContainer: {
        flex: 1,
        borderWidth: rem(1),
        alignItems: 'center',
        borderRadius: rem(16),
        paddingVertical: rem(16),
        borderColor: colors.borders.divider,
    },
    deckContainer: {
        height: rem(148),
        marginTop: rem(32),
        marginBottom: rem(16),
    },
    title: {
        alignSelf: 'center',
        marginHorizontal: rem(16),
    },
}));
export default OnboardingHowFreeTrialWorksWarningModalContent;
